export default {
  props: {
    csrfField: {type: String, default: null}
  },
  methods: {
    getToken()
    {
      return this.$el
        .querySelector(`input[name="${this.csrfField}"]`)
        .value;
    }
  }
};
